import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import miFooter from './miFooter.css';
import certificada from './Certificada-01.png';
import fincEU from './fincEU.png';
import logoEOI from './logoEOI.jpg';
import logoMinisterio from './logoMinisterio.jpg';
import logoJunta2 from './logoJunta2.png';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {ContentPoliticaPrivacidad} from '../varios/ContentPoliticaPrivacidad';

export const MiFooter = () => {
	const [ModalPrivacidad, setModalPrivacidad] = useState(false);
	return (
		<>
			<div className="footer-top centrador p-4">
				<p className='px-3'>
					Todos nuestros profesionales cuentan con cédula profesional vigente y están homologados por la Administración Pública. Servicios garantizados bajo normativa de Seguridad Social.
				</p>
			</div>
			<div className='Mifooter'>
				<div className='element-miFooter centrador'>
					<p>
						Cuidatia ha sido apoyada por el Ministerio de Industria, Comercio y Turismo
						y la Fundación EOI, FSP, así como por la Junta de Extremadura. Del mismo
						modo, ha sido financiada por el Mecanismo de Recuperación y Resilencia.
					</p>
				</div>
				<div className='financiacion-footer'>
					<div className='element-miFooter centrador'>
						{' '}
						<img src={fincEU} alt='Unión Europea'/>
					</div>
					<div className='element-miFooter centrador'>
						{' '}
						<img src={logoMinisterio} alt='Ministerio de Industria, Turismo y comercio'/>
					</div>
					<div className='element-miFooter centrador logoJunta'>
						{' '}
						<img src={logoJunta2} alt='Junta de Extremadura'/>
					</div>
					<div className='element-miFooter centrador'>
						{' '}
						<img src={logoEOI} alt='Escuela de Organiación Industrial'/>
					</div>
					<div className='element-miFooter centrador'>
						<img src={certificada} alt='Certificada' className='certificada' />
					</div>
				</div>
				<div className="footer-layout">

					<div className='enlazes-footer enlaces-redes'>
						<div className='centrador'>
							<a
								href='https://x.com/Cuidatia'
								target='_blank'
								rel='noreferrer'
								className='icon icon-X'
							>
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
									<path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
								</svg>
								{/* <span>X</span> */}
							</a>
						</div>
						<div className='centrador'>
							<a
								href='https://www.linkedin.com/company/93218668/'
								target='_blank'
								rel='noreferrer'
								className='icon icon-LinkedIn'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='20'
									height='20'
									fill='currentColor'
									className='bi bi-linkedin'
									viewBox='0 0 16 16'
								>
									<path d='M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z' />
								</svg>
								{/* <span>LinkedIn</span> */}
							</a>
						</div>
						<div className='centrador'>
							<a
								href='mailto:cuidatia@cuidatia.org'
								target='_blank'
								rel='noreferrer'
								className='icon icon-Mail'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='20'
									height='20'
									fill='currentColor'
									className='bi bi-envelope-fill'
									viewBox='0 0 16 16'
								>
									<path d='M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z' />
								</svg>
								{/* <span>Mail</span> */}
							</a>
						</div>
						<div className='centrador'>
							<a
								href='https://www.youtube.com/channel/UCOEdDaKK9NuYcYXA3WL9lUQ'
								target='_blank'
								rel='noreferrer'
								className='icon icon-Youtube'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='20'
									height='20'
									fill='currentColor'
									className='bi bi-youtube'
									viewBox='0 0 16 16'
								>
									<path d='M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z' />
								</svg>
								{/* <span>Youtube</span> */}
							</a>
						</div>
						<div className='centrador'>
							<a
								href='https://www.instagram.com/cuidatia_/'
								target='_blank'
								rel='noreferrer'
								className='icon icon-Instagram'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='20'
									height='20'
									fill='currentColor'
									className='bi bi-instagram'
									viewBox='0 0 16 16'
								>
									<path d='M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334' />
								</svg>
								{/* <span>Instagram</span> */}
							</a>
						</div>
						<div className='centrador'>
							<a
								href='https://www.facebook.com/profile.php?id=61555183482499&locale=es_ES'
								target='_blank'
								rel='noreferrer'
								className='icon icon-Facebook'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='20'
									height='20'
									fill='currentColor'
									className='bi bi-facebook'
									viewBox='0 0 16 16'
								>
									<path d='M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951' />
								</svg>
								{/* <span>Facebook</span> */}
							</a>
						</div>
					</div>

					<div className='enlazes-footer'>
					<div
							className='icon-footer centrador'
						>
							<a href="/">Inicio</a>
						</div>
						<div
							className='icon-footer centrador'
						>
							<Link to="/sobre-nosotros">Sobre Nosotros</Link>
						</div>
						<div
							className='icon-footer centrador'
						>
							<a href="/club-cuidatia">Club Cuidatia</a>
						</div>
						<div
							className='icon-footer centrador'
						>
							<a href="/soporte">Soporte</a>
						</div>
					</div>

					<div className='enlazes-footer'>
						<div
							className='icon-footer centrador'
						>
							<a href="/politica-privacidad" target='_blank'>Política de Privacidad</a>
						</div>
						<div
							className='icon-footer centrador'
						>
							<a href="/politica-cookies" target='_blank'>Política de Cookies</a>
						</div>
						<div
							className='icon-footer centrador'
						>
							<a href="/aviso-legal" target='_blank'>Aviso Legal</a>
						</div>
						<div
							className='icon-footer centrador'
						>
							<a href="/preguntas-frecuentes" target='_blank'>Preguntas Frecuentes</a>
						</div>
					</div>

				</div>				
				
				<div className='centrador'>
					<div>&reg; {
						new Date().getFullYear()
					} Copyright <strong>CUIDATIA</strong>. Todos los derechos reservados.</div>
				</div>
			</div>
		</>
	);
};
